// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8Fect","imageWrapperNotFound":"styles_imageWrapperNotFound__VK_9s","imageWrapper":"styles_imageWrapper__4jXg6","icon":"styles_icon__puXDN","title":"styles_title__4wYz_","text":"styles_text__GRbrB","subText":"styles_subText__y2ap_"};
module.exports.__checksum = "ff95a61ac9c7"
